export default __webpack_public_path__ + "static/media/arrow.032b5e48.png";